import { BASE_API_URL } from './index';

// eslint-disable-next-line import/prefer-default-export
export const getThreadEndpoint = (threadId) => `${BASE_API_URL}/messaging/thread/${threadId}/`;
